/**
 * House of Neoma — PDP Afterpay placement.
 *
 * The Afterpay on-site messaging app block belongs directly beneath the product
 * price row (after the price / compare-at / sale badge, before the size
 * selector and Add to Cart), not below Add to Cart, Shop Pay, Apple Pay or
 * "More payment options".
 *
 * main-product.liquid + hon-block-zone.liquid already route the app block into
 * the price ("identity") zone server-side, so on a normal render this script is
 * a no-op. It exists as a guarded safety net for the case where a placement
 * still ends up below the buy buttons — for example an app that injects its
 * message independently of the theme's block routing.
 *
 * It never edits the Afterpay output, amount, badge, modal or behaviour: it
 * only relocates the existing placeholder wrapper and hides a genuine duplicate
 * lower placement so the message is never shown twice.
 */
(function () {
  'use strict';

  var INFO_SELECTOR = '.product__info-container';
  var FORM_SELECTOR = 'form[action*="/cart/add"]';
  var PRICE_SELECTOR = '[id^="price-"]';
  var MARKER_SELECTOR = 'square-placement, [id*="afterpay" i], .afterpay-paragraph';

  function isAfter(node, reference) {
    if (!node || !reference) return false;
    return !!(reference.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_FOLLOWING);
  }

  function isAfterpayNode(node) {
    if (!node || typeof node.querySelector !== 'function') return false;
    // The app block wrapper id carries the app handle
    // (shopify-block-...__afterpay_on_site_messaging_...) even before the app
    // script has hydrated square-placement.
    if (node.id && /afterpay/i.test(node.id)) return true;
    return !!node.querySelector(MARKER_SELECTOR);
  }

  function afterpayNodes(info) {
    var nodes = [];
    Array.prototype.forEach.call(info.children, function (child) {
      if (isAfterpayNode(child)) nodes.push(child);
    });
    return nodes;
  }

  function place() {
    var info = document.querySelector(INFO_SELECTOR);
    if (!info) return;

    var nodes = afterpayNodes(info);
    if (!nodes.length) return;

    var price = info.querySelector(PRICE_SELECTOR) || info.querySelector('.price');
    if (!price) return;

    var form = info.querySelector(FORM_SELECTOR);
    var primary = nodes[0];

    // Correct = after the price row and before the buy buttons. Anything else
    // (in particular a placement below Add to Cart / dynamic checkout) is moved
    // back up next to the price.
    var inPriceZone = isAfter(primary, price) && !isAfter(primary, form);
    if (!inPriceZone) {
      primary.classList.add('hon-afterpay-message');
      primary.setAttribute('data-hon-afterpay-near-price', '');
      price.insertAdjacentElement('afterend', primary);
    }

    // Only a genuine second placement that sits below the buy buttons is
    // suppressed, so the instalment message can never appear twice.
    for (var i = 1; i < nodes.length; i++) {
      var extra = nodes[i];
      if (isAfter(extra, form)) {
        extra.hidden = true;
        extra.style.display = 'none';
        extra.setAttribute('data-hon-afterpay-duplicate', '');
      }
    }
  }

  function run() {
    place();
    // The app script can hydrate slightly after first paint.
    window.setTimeout(place, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
})();
